import React from "react";
import MapSVG from "assets/icons/map.inline.svg";

import Icon from "./Icon";

const MapIcon = ({ ...rest }) => (
	<Icon
		name="map"
		alt="Map"
		{...rest}
	>
		<MapSVG />
	</Icon>
);

export default MapIcon;
